function convertnumber(number) {
    return Number((Number(number)).toFixed(1)).toLocaleString(['ban', 'id'])
    // return Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    // return String(number).replace(/(?:(^\d{1,3})(?=(?:\d{3})*$)|(\d{3}))(?!$)/mg, '$1$2.')
}
export default convertnumber;